// HELPERS
import tableFilter from '../../../../helpers/tableFilter';

// UTILS
import naUTL from '../../../../../../utils/naUTL';

const jsonTableRow = (dataSources) => {
  const { creditBureau, residential, watchlistAML } = dataSources;

  const table = [
    {
      col1: 'Status',
      col2: naUTL(residential.status),
      col3: naUTL(watchlistAML.status),
      col4: naUTL(creditBureau.status),
    },
    {
      col1: 'Safe Harbour Score',
      col2: naUTL(residential.safeHarbourScore),
      col3: naUTL(watchlistAML.safeHarbourScore),
      col4: naUTL(creditBureau.safeHarbourScore),
    },
    {
      col1: 'Identity Verified',
      col2: naUTL(residential.identityVerified),
      col3: naUTL(watchlistAML.identityVerified),
      col4: naUTL(creditBureau.identifyVerified),
    },
    {
      col1: 'National ID No',
      col2: naUTL(residential.verifications.nationalIDNo),
      col3: naUTL(watchlistAML.verifications.nationalIDNo),
      col4: naUTL(creditBureau.verifications.nationalIDNo),
    },
    {
      col1: 'First Name Verified',
      col2: naUTL(residential.verifications.firstName),
      col3: naUTL(watchlistAML.verifications.firstName),
      col4: naUTL(creditBureau.verifications.firstName),
    },
    {
      col1: 'Middle Name Verified',
      col2: naUTL(residential.verifications.middleName),
      col3: naUTL(watchlistAML.verifications.middleName),
      col4: naUTL(creditBureau.verifications.middleName),
    },
    {
      col1: 'Last Name Verified',
      col2: naUTL(residential.verifications.lastName),
      col3: naUTL(watchlistAML.verifications.lastName),
      col4: naUTL(creditBureau.verifications.lastName),
    },
    {
      col1: 'Date Of Birth Verified',
      col2: naUTL(residential.verifications.dateOfBirth),
      col3: naUTL(watchlistAML.verifications.dateOfBirth),
      col4: naUTL(creditBureau.verifications.dateOfBirth),
    },
    {
      col1: 'Gender Verified',
      col2: naUTL(residential.verifications.gender),
      col3: naUTL(watchlistAML.verifications.gender),
      col4: naUTL(creditBureau.verifications.gender),
    },
    {
      col1: 'Name Match Score',
      col2: naUTL(residential.nameMatchScore),
      col3: naUTL(watchlistAML.nameMatchScore),
      col4: naUTL(creditBureau.nameMatchScore),
    },
    {
      col1: 'Street Verified',
      col2: naUTL(residential.verifications.addressElement1),
      col3: naUTL(watchlistAML.verifications.addressElement1),
      col4: naUTL(creditBureau.verifications.addressElement1),
    },
    {
      col1: 'City Verified',
      col2: naUTL(residential.verifications.city),
      col3: naUTL(watchlistAML.verifications.city),
      col4: naUTL(creditBureau.verifications.addressElement3),
    },
    {
      col1: 'Barangay Verified',
      col2: naUTL(residential.verifications.barangay),
      col3: naUTL(watchlistAML.verifications.barangay),
      col4: naUTL(creditBureau.verifications.addressElement2),
    },
    {
      col1: 'Province Verified',
      col2: naUTL(residential.verifications.province),
      col3: naUTL(watchlistAML.verifications.province),
      col4: naUTL(creditBureau.verifications.addressElement4),
    },
    {
      col1: 'Post Code Verified',
      col2: naUTL(residential.verifications.postcode),
      col3: naUTL(watchlistAML.verifications.postcode),
      col4: naUTL(creditBureau.verifications.addressElement5),
    },
    {
      col1: 'Address Match Score',
      col2: naUTL(residential.addressMatchScore),
      col3: naUTL(watchlistAML.addressMatchScore),
      col4: naUTL(creditBureau.addressMatchScore),
    },
  ];

  return tableFilter(table);
};

export default jsonTableRow;
